export default "__VITE_ASSET__JTv7cI3d__"